import React, { Fragment } from "react";
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faFolder } from "@fortawesome/free-solid-svg-icons";
import { CustomInput } from "reactstrap";
import { Row } from 'reactstrap';
import Submenu from './Submenu';

const StatusOptions = [
    // { value: 'Favourites', label: 'Favourites' },
    { value: 'Filled', label: 'Filled' },
    { value: 'Blank', label: 'Blank' },
];

class Sidemenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            statusFilter: [],


            selectedParentMenu: '',
            viewingParentMenu: '',
            domains: [],
            selectedCategory: {},

        };
    }

    componentDidMount() {
        var filterStatusList = [];
        StatusOptions.map((l) => filterStatusList.push({ ...l, checked: false }));
        this.setState({ statusFilter: filterStatusList });

    }

    handleCheckedStatusFilter = (e) => {
        const { statusFilter } = this.state;
        const updatedStatusFilter = statusFilter.map((item) =>
            item.value === e.target.id
                ? { ...item, checked: !item.checked }
                : item
        );

        this.setState({ statusFilter: updatedStatusFilter }, () => {

            const selectedFilters = updatedStatusFilter.filter(item => item.checked).map(item => item.value);
            this.props.onFilterChange(selectedFilters);
        });
    };


    render() {
        const { statusFilter, selectedCategory } = this.state;
        const { allCount, filledCount, blankCount } = this.props;
        const shouldRenderCategories = allCount !== undefined && allCount !== null;
        // && allCount.length === '0';

        return (
            <div className="app-menu app-ticketing">
                {/* Status Filter Section */}
                <Row className="ml-1">
                    <Colxx xxs="12" className="mt-4">
                        <h6>
                            <FontAwesomeIcon icon={faFilter} style={{ color: 'var(--theme-color-1)' }} />
                            Status
                        </h6>
                    </Colxx>
                    <Colxx xxs="10" className="text-left">
                        <CustomInput
                            type="checkbox"
                            id={'All'}
                            value={'-1'}
                            label={'All'}
                            checked={statusFilter.filter(m => m.checked === true).length === 0}
                            onClick={this.handleCheckedStatusFilter}
                        />
                    </Colxx>
                    <Colxx xxs="2" className="text-center">
                        {allCount === undefined ? 0 : allCount.length}
                    </Colxx>
                    {statusFilter.map((item, index) => (
                        <Fragment key={index}>
                            <Colxx xxs="10" className="text-left">
                                <CustomInput
                                    type="checkbox"
                                    id={item.value}
                                    value={item.value}
                                    label={item.label}
                                    checked={item.checked}
                                    onClick={this.handleCheckedStatusFilter}
                                />
                            </Colxx>
                            <Colxx xxs="2" className="text-center">
                                {item.value === 'Filled' ? filledCount : item.value === 'Blank' ? blankCount : 0}
                            </Colxx>
                        </Fragment>
                    ))}
                </Row>

                {shouldRenderCategories && (
                    <Row className="ml-1">

                        <Colxx xxs="12" className="mt-4">
                            <h6>
                                <FontAwesomeIcon icon={faFolder} style={{ color: 'var(--theme-color-1)' }} className="mr-2" />
                                Categories
                            </h6>
                        </Colxx>

                        <Submenu selectedCategory={selectedCategory} allCount={allCount} />
                    </Row>
                )}
            </div>
        );
    }
}

export default Sidemenu;
